import { IContact } from 'clickNgo/entities/contact'
import { IForm } from 'core-components/classes/models/IForm'

export const mapContactFromCrud = (data: IForm): Partial<IContact> => ({
  email: data.Email,
  contactId: data.ContactID,
  partnerId: data.PartnerID,
  workflowStatus: data.WorkflowStatus,
  source: data.Source,
  countryOfBusiness: data.CountryOfBusiness,
  firstName: data.FirstName,
  lastName: data.LastName,
  market: data.Market,
  mobilePhoneNumber: data.MobilePhone,
  mobilePhoneCode: data.MobilePhone_Prefix,
  isNeverCall: data.NeverCall === 'Y',
  isNeverEmail: data.NeverEmail === 'Y',
  hpRoles: data.PR_HP_ROLE.split(','),
  preferredLanguage: data.PreferredLanguage,
  primaryJobRole: data.PrimaryJobRole.split(';').filter(Boolean),
  salutation: data.Salutation,
  seniority: data.Seniority,
  status: data.Status,
  workPhoneNumber: data.WorkPhone,
  workPhoneCode: data.WorkPhone_Prefix,
})
